/* eslint-disable no-console, no-eval */
import detect from 'feature-detect-es6';

detect.fetch = () => {
  try {
    eval('fetch');
    return true;
  } catch (err) {
    return false;
  }
};

const polyfillScript = document.getElementById('polyfill-script');

if (!detect.all('class', 'spread', 'destructuring', 'let', 'const', 'arrowFunction', 'generators', 'defaultParamValues', 'templateStrings', 'collections', 'newArrayFeatures', 'promises', 'fetch')) {
  console.log('No es2017, using es5 and polyfills. We recommend using a modern browser such as the latest versions of Firefox, Opera, Chrome, Edge, or Safari.');
  const babelPolyfillScript = document.createElement('script');
  babelPolyfillScript.src = '/assets/dist/js/babel-polyfill.min.js';
  document.body.insertBefore(babelPolyfillScript, polyfillScript);
  const fetchScript = document.createElement('script');
  fetchScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/fetch/2.0.3/fetch.min.js';
  document.body.insertBefore(fetchScript, polyfillScript);
}
/* eslint-enable no-console, no-eval  */
